<template>
		<el-col>
			<div class="flex-row align-items-center space-between route-down">
				
				<el-form :model="form" inline style="margin-top: 10px;">
						<el-form-item label="类型">
								<el-select v-model="form.typeCate" placeholder="请选择">
										<el-option v-for="item in BaseDictionaryList_typeDDL" :key="(item.orderId+item.typeCate)"
															 :label="item.typeCate"
															 :value="item.typeCate"></el-option>
								</el-select>
						</el-form-item>
						<el-form-item label="关键字">
								<el-input v-model="form.key"></el-input>
						</el-form-item>
						<el-button @click="onSearch" type="primary" icon="el-icon-search">搜索</el-button>

				</el-form>
				<el-button @click="addDataObjectDialogVisible=true" type="primary" style="margin-right:10px;">新增字典</el-button>
			</div>
			<div class="radius-border-post">
				<data-object-table/>
			</div>
				<add-data-object-dialog :visible.sync="addDataObjectDialogVisible"/>
		</el-col>
</template>

<script>
import DataObjectTable from "@/views/System/Setting/Dictionary/DataObjectTable";
import {mapGetters} from "vuex";
import AddDataObjectDialog from "@/views/System/Setting/Dictionary/AddDataObjectDialog";

export default {
		name: "index",
		components: {AddDataObjectDialog, DataObjectTable},
		computed: {
				...mapGetters(['BaseDictionaryList_typeDDL'])
		},
		async created() {
      // console.log('bb');
        await this.$store.dispatch('setting/BaseDictionaryList_typeDDL');
        // console.log('aa',this.BaseDictionaryList_typeDDL);
				this.onSearch();
		},
		data() {
				return {form: { typeCate: '全部', key: ''}, addDataObjectDialogVisible: false};
		},
		methods: {
				async onSearch() {
						const {key, typeCate} = this.form;
						await this.$store.dispatch('setting/BaseDictionaryList', {key, typeCate});
				}
		}
}
</script>

<style scoped>

</style>